import { styled } from "@mui/material";
import Component from "./component";
import { IWithThemeProps } from "../../../theme/default.theme";

export default styled(Component)(({ theme }: IWithThemeProps) => ({
  width: "100%",
  ".user-type": {
    justifyContent: "space-between",
    ".MuiFormControlLabel-root": {
      width: "47%",
      height: 70,
    },
    ".tree-icon": {
      padding: theme?.spacing(2),
      backgroundColor: "#fff",
      borderRadius: 3,
    },
  },
  ".full-width": {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
  },
  ".half-width": {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  ".radio-container": {
    margin: theme?.spacing(1),
    textAlign: "left",
    ".MuiTypography-root": {
      fontWeight: 600,
    },
  },
  ".tc-container": {
    margin: theme?.spacing(1),
    padding: theme?.spacing(0, 1),
    ".MuiTypography-root": {
      color: theme?.palette.text.gray,
      fontSize: 12,
      fontWeight: 500,
      a: {
        fontWeight: 800,
        textDecoration: "underline",
        color: theme?.palette.text.gray,
      },
    },
    ".MuiSvgIcon-root": {
      width: 20,
    },
    ".tc-label": {
      textAlign: "left",
      ".MuiFormHelperText-root": {
        marginLeft: 0,
      },
    },
  },
}));
